import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SessionEventsService {
  private readonly resetSubject = new Subject<void>();
  private readonly remoteResetSubject = new Subject<void>();
  private readonly channel = typeof BroadcastChannel === 'undefined'
    ? null
    : new BroadcastChannel('vby-session');
  readonly reset$ = this.resetSubject.asObservable();
  readonly remoteReset$ = this.remoteResetSubject.asObservable();

  constructor() {
    this.channel?.addEventListener('message', (event: MessageEvent) => {
      if (event.data?.type === 'session-reset') {
        this.resetSubject.next();
        this.remoteResetSubject.next();
      }
    });
  }

  notifyReset(): void {
    this.resetSubject.next();
    this.channel?.postMessage({ type: 'session-reset' });
  }
}
